function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "198.075 65.5713 153.32 133.4868",
    width: "153.32px",
    height: "133.487px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 276.578 186.954 C 279.126 185.941 280.364 183.049 279.345 180.508 C 278.325 177.96 275.433 176.722 272.892 177.742 L 276.578 186.954 Z M 341.468 122.6 C 341.468 125.347 343.692 127.564 346.432 127.564 C 349.172 127.564 351.395 125.347 351.395 122.6 L 341.468 122.6 Z M 342.269 87.478 L 340.429 92.091 L 342.269 87.478 Z M 296.174 71.013 L 298.021 75.619 L 296.174 71.013 Z M 301.092 71.013 L 299.245 75.619 L 301.092 71.013 Z M 207.201 174.452 L 205.355 179.059 L 207.201 174.452 Z M 253.296 190.925 L 255.136 195.531 L 253.296 190.925 Z M 248.379 190.925 L 250.219 186.319 L 248.379 190.925 Z M 272.892 177.742 L 251.45 186.319 L 255.136 195.531 L 276.578 186.954 L 272.892 177.742 Z M 250.219 186.319 L 209.041 169.846 L 205.355 179.059 L 246.532 195.531 L 250.219 186.319 Z M 208.002 168.311 L 208.002 79.801 L 198.075 79.801 L 198.075 168.311 L 208.002 168.311 Z M 210.272 78.266 L 246.532 92.773 L 250.219 83.554 L 213.958 69.047 L 210.272 78.266 Z M 255.136 92.773 L 298.021 75.619 L 294.334 66.4 L 251.45 83.554 L 255.136 92.773 Z M 299.245 75.619 L 340.429 92.091 L 344.115 82.872 L 302.931 66.4 L 299.245 75.619 Z M 341.468 93.626 L 341.468 122.6 L 351.395 122.6 L 351.395 93.626 L 341.468 93.626 Z M 340.429 92.091 C 341.051 92.342 341.468 92.951 341.468 93.626 L 351.395 93.626 C 351.395 88.888 348.51 84.632 344.115 82.872 L 340.429 92.091 Z M 298.021 75.619 C 298.411 75.46 298.855 75.46 299.245 75.619 L 302.931 66.4 C 300.172 65.295 297.094 65.295 294.334 66.4 L 298.021 75.619 Z M 246.532 92.773 C 249.299 93.878 252.376 93.878 255.136 92.773 L 251.45 83.554 C 251.059 83.713 250.616 83.713 250.219 83.554 L 246.532 92.773 Z M 208.002 79.801 C 208.002 78.63 209.187 77.829 210.272 78.266 L 213.958 69.047 C 206.348 66.003 198.075 71.608 198.075 79.801 L 208.002 79.801 Z M 209.041 169.846 C 208.413 169.595 208.002 168.986 208.002 168.311 L 198.075 168.311 C 198.075 173.043 200.961 177.305 205.355 179.059 L 209.041 169.846 Z M 251.45 186.319 C 251.059 186.471 250.616 186.471 250.219 186.319 L 246.532 195.531 C 249.299 196.636 252.376 196.636 255.136 195.531 L 251.45 186.319 Z",
    fill: "#71717A",
    style: {},
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 250.834 89.146 L 250.834 189.515",
    stroke: "#71717A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {},
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 298.636 74.805 L 298.636 117.822",
    stroke: "#71717A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {},
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(245, 17, 17)",
      strokeWidth: 22,
      strokeLinecap: "round"
    },
    d: "M 348.057 199.058 L 270.91 118.375",
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(245, 17, 17)",
      strokeWidth: 22,
      strokeLinecap: "round",
      transformOrigin: "309.188px 158.717px"
    },
    d: "M 347.762 118.375 L 270.615 199.058",
    transform: "matrix(-1, 0, 0, -1, 0.000061035156, 0)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapDelete);
export default __webpack_public_path__ + "static/media/map-delete.7acfa9a0dc57211e93f8624c96379b6f.svg";
export { ForwardRef as ReactComponent };